<form
  class="edit-form"
  *ngIf="!isLoading && clients && dictionaries"
  [formGroup]="editForm"
  (submit)="onSubmit()"
>
  <mat-form-field>
    <mat-label>{{
      "repository.transportTypes.edit.name.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="name" />
    <mat-error>{{
      "repository.transportTypes.edit.name.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <app-autocomplete
    [control]="getControl('dictionary')"
    [list]="dictionaries"
    label="repository.transportTypes.edit.dictionary.label"
    errorMsg="repository.transportTypes.edit.dictionary.errorMessage"
  >
  </app-autocomplete>

  <app-autocomplete
    [control]="getControl('client')"
    [list]="clients"
    (changeEvent)="onClientChange()"
    label="repository.transportTypes.edit.client.label"
    errorMsg="repository.transportTypes.edit.client.errorMessage"
  >
  </app-autocomplete>

  <mat-form-field *ngIf="editForm.get('dictionary').value?.code === 'transport-types'">
    <mat-label>Température (optionnelle)</mat-label>
    <mat-select formControlName="temperature">
      <mat-option [value]="null">Aucune</mat-option>
      <mat-option *ngFor="let t of temperatureOptions" [value]="t">{{ t }}°</mat-option>
    </mat-select>
  </mat-form-field>

  <fieldset class="sites-list" *ngIf="sites.length > 0">
    <legend>
      <h3>{{ "users.edit.sites.title" | translate }}</h3>
    </legend>
    <mat-list formArrayName="sites">
      <mat-list-item
        *ngFor="let siteControl of getArray('sites').controls; index as i"
      >
        <section class="form-field">
          <app-autocomplete
            [control]="siteControl"
            [list]="selectableSites"
            (changeEvent)="generateSelectableSites()"
            label="users.edit.sites.select.label"
            errorMsg="users.edit.sites.select.errorMessage"
          >
          </app-autocomplete>
        </section>

        <button
          type="button"
          mat-icon-button
          color="primary"
          (click)="onRemoveSite(i)"
        >
          <mat-icon aria-label="delete">delete</mat-icon>
        </button>
      </mat-list-item>
      <mat-list-item>
        <button
          type="button"
          mat-icon-button
          color="primary"
          (click)="onAddSite()"
        >
          <mat-icon aria-label="Add">add</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </fieldset>

  <app-validate-and-cancel
    (submitEvent)="endForm($event)"
    [editForm]="editForm"
    [disabling]="editForm.invalid"
  ></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
